import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

const ERINNERUNG = [['email', 'E-Mail'], ['sms', 'SMS'], ['beides', 'E-Mail und SMS'], ['keine', 'Keine']];

export const Benachrichtigungen = () => {
  const [b, setB] = useState(null);
  const [msg, setMsg] = useState('');
  useEffect(() => { api.get('/konto/benachrichtigungen').then((r) => setB(r.data)).catch(() => setB(false)); }, []);
  if (b === null) return <Loader2 className="w-4 h-4 animate-spin text-[#b8893d]" />;
  if (!b) return null;
  const speichern = async () => {
    setMsg('');
    try { const r = await api.put('/konto/benachrichtigungen', b); setB(r.data); setMsg('Gespeichert'); } catch (e) { setMsg(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
  };
  const sms = b.sms_hinweis || ['sms', 'beides'].includes(b.erinnerung);
  return (
    <div className="space-y-3 text-sm" data-testid="benachrichtigungen">
      <p className="text-xs text-gray-500">E-Mails enthalten nie Inhalte, nur den Hinweis auf Neues im Portal.</p>
      <label className="flex items-center gap-2 text-[#1B3A5C]"><input type="checkbox" checked={!!b.sms_hinweis} onChange={(e) => setB({ ...b, sms_hinweis: e.target.checked })} className="accent-[#b8893d]" data-testid="benachrichtigung-sms" />Zusätzlich SMS-Hinweis bei Neuem im Portal</label>
      <div className="flex flex-wrap items-center gap-2"><span className="text-[#1B3A5C]">Terminerinnerung am Vortag:</span>
        {ERINNERUNG.map(([k, l]) => <button key={k} type="button" onClick={() => setB({ ...b, erinnerung: k })} aria-pressed={b.erinnerung === k} data-testid={`benachrichtigung-erinnerung-${k}`}
          className={`h-8 px-3 rounded-full text-xs border ${b.erinnerung === k ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'bg-white text-[#1B3A5C] border-gray-200'}`}>{l}</button>)}
      </div>
      {sms && <input value={b.sms_nummer || ''} onChange={(e) => setB({ ...b, sms_nummer: e.target.value })} placeholder="Mobilnummer, z. B. +49 170 1234567" className="w-64 px-3 py-2 border border-gray-200 rounded-[10px] text-sm" data-testid="benachrichtigung-nummer" />}
      <div className="flex items-center gap-3">
        <button type="button" onClick={speichern} className="h-9 px-4 rounded-[10px] bg-[#1B3A5C] text-white text-sm" data-testid="benachrichtigung-speichern">Speichern</button>
        {msg && <span className="text-xs text-[#34536b]" data-testid="benachrichtigung-msg">{msg}</span>}
      </div>
      {sms && <p className="text-[11px] text-amber-700">Hinweis: Der SMS-Versand wird gerade eingerichtet. Ihre Auswahl ist gespeichert und gilt, sobald er aktiv ist.</p>}
    </div>
  );
};
